import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/progettazione-ponte-roma.webp")